<template>
  <span v-if="mostrar" class="chip" :class="`chip-${variant}`">{{ label }}</span>
</template>

<script>
/**
 * Etiqueta da faixa etaria, para a portaria saber de quem pedir documento.
 *
 * Inteira nao ganha etiqueta: e a maioria das linhas, e marcar todas afogaria
 * justamente as duas que precisam de conferencia. Quem tem etiqueta e quem
 * paga menos — que e exatamente onde o voluntario tem de olhar.
 */
const FAIXAS = {
  MEIA: { label: 'Meia', variant: 'info' },
  ISENTA: { label: 'Isenta', variant: 'warning' }
}

export default {
  name: 'FaixaChip',
  props: {
    tipo: { type: String, default: 'INTEIRA' },
    // Quando a tela quiser rotular todo mundo, inclusive as inteiras.
    sempre: { type: Boolean, default: false }
  },
  computed: {
    config() {
      return FAIXAS[this.tipo] || { label: 'Inteira', variant: 'muted' }
    },
    mostrar() { return this.sempre || !!FAIXAS[this.tipo] },
    label() { return this.config.label },
    variant() { return this.config.variant }
  }
}
</script>

<style scoped>
.chip {
  display: inline-block;
  font-size: 11px; font-weight: 700; letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 3px 8px; border-radius: 4px;
}
.chip-info { background: #dbeafe; color: #1d4ed8; }
.chip-warning { background: #fef3c7; color: #92400e; }
.chip-muted { background: #f3f4f6; color: #4b5563; }
</style>
